import { DefaultResponse, FileProps } from '@/common/types/common'
import { apiService } from './apiService'
import { companyEndpoints, fileEndpoints } from '@/api/apiEndpoint'

export interface CompanyData { 
  id: number;
  name: string;
  businessNumber: string;
  ceoName: string[];
  code: string;
  description: string;
  logo: string;
}
export interface CheckExistCompanyResponse {
  isExist: boolean;
  company?: {
    id: number;
    name: string;
    ceoName: string;
    description: string;
    businessNumber: string;
    logo: string;
    masterUser?: {
      id: number;
      name: string;
      email: string;
    }
  };
}
interface CheckCompanyStatusData {
  companyName: string
  ceoName: string
  businessNumber: string
  corporateNumber: string
  establishedDate: string
}

interface CheckCompanyStatusResponse {
  isExistCompany: boolean;
  isCertifiedCompanyName: boolean; 
}

export interface RegisterUserAndCompanyData {
  notificationId: string;
  companyEmail: string;
  companyEmailVerified: boolean;
  companyCode: string;
  isVerified: boolean;
  isPreStartup: boolean;
  isCeo: boolean;
  companyName: string;
  companyNameEn?: string;
  businessNumber?: string;
  corporateNumber?: string;
  isBusinessVerified?: boolean;
  residentNumber?: string;
  foundingDate?: string;
  ceoName: string;
  ceoEmail: string;
  name: string;
  phone: string;
  email: string;
  emailVerified: boolean;
  loginId?: string;
  password: string;
  userDi: string;
  userCi: string;
  token: string;
}

export interface RegisterCompanyData {
  notificationId: string;
  companyEmail: string;
  companyEmailVerified: boolean;
  companyCode: string;
  isVerified: boolean;
  isPreStartup: boolean;
  isCeo: boolean;
  companyName: string;
  companyNameEn?: string;
  businessNumber?: string;
  corporateNumber?: string;
  isBusinessVerified?: boolean;
  foundingDate?: string;
  ceoName: string;
  ceoEmail: string;
}

export const companyService = {
  async checkCompanyStatus(data: CheckCompanyStatusData): Promise<CheckCompanyStatusResponse> {
    const key = "9bBWSMsQwxGfVp%2Fe2oQCWfK0q%2FU0sYYP0rSUVzPWT1Vd0SYxBgxYNWKcu8PRSzHJHNvvEOSwE%2FKlZW8Uco59uA%3D%3D"
    const url = `https://api.odcloud.kr/api/nts-businessman/v1/validate?serviceKey=${key}&returnType=JSON`
    
    const firstBody = {
      businesses: [
        {
          b_no: data.businessNumber,
          start_dt: data.establishedDate,
          p_nm: data.ceoName,
          corp_no: data.corporateNumber,
        }
      ]
    }

    const secondBody = {
      businesses: [
        {
          b_nm: data.companyName,
          b_no: data.businessNumber,
          start_dt: data.establishedDate,
          p_nm: data.ceoName,
          corp_no: data.corporateNumber,
        }
      ]
    }

    try {
      const firstResponse = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(firstBody),
      }).then(res => res.json());

      if(firstResponse.data[0].valid !== '01'){
        return {
          isExistCompany: false,
          isCertifiedCompanyName: false,
        }
      }
      
      const secondResponse = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(secondBody),
      }).then(res => res.json());

      return {
        isExistCompany: true,
        isCertifiedCompanyName: secondResponse.data[0].valid === '01',
      }
      
    } catch (err: any) {
      console.error(err)
      return {
        isExistCompany: false,
        isCertifiedCompanyName: false,
      }
    }
  },

  async checkExistCompany(businessNumber: string): Promise<CheckExistCompanyResponse> {
    try {
      const response = await apiService.post<CheckExistCompanyResponse>(companyEndpoints.checkExistCompany(), {businessNumber});
      return response;
    } catch (error) {
      return {
        isExist: false,
      }
    }

  },

  async registerUserAndCompany(data: any): Promise<DefaultResponse> {
    try {
      const response = await apiService.post<DefaultResponse>(companyEndpoints.registerUserAndCompany(), data);
      return response;
    } catch (error: any) {
      // 서버에서 반환한 에러 메시지가 있으면 사용, 없으면 기본 메시지
      const errorMessage = error?.response?.data?.message || error?.message || '회원 가입 중 오류가 발생했습니다.';
      return {
        success: false,
        message: errorMessage
      };
    }
  },

  async registerCompany(data: any): Promise<DefaultResponse> {
    try {
      const response = await apiService.post<DefaultResponse>(companyEndpoints.registerCompany(), data);
      return response;
    } catch (error: any) {
      // 서버에서 반환한 에러 메시지가 있으면 사용, 없으면 기본 메시지
      const errorMessage = error?.response?.data?.message || error?.message || '회사 등록 중 오류가 발생했습니다.';
      return {
        success: false,
        message: errorMessage
      };
    }
  },


  async applyCompanyJoinRequest(data: {
    companyId: number; email: string;
  }): Promise<DefaultResponse> {
    try {
      const response = await apiService.post<DefaultResponse>(companyEndpoints.applyCompany(), data);
      return response;
    } catch (error: any) {
      return {
        success: false,
        message: error?.response?.data?.message || error?.message || '회사 가입 신청 중 오류가 발생했습니다.'
      };
    }
  },

  async matchingCompany(data: {
    serviceType: string; companyId: number; email: string; businessPlanFileId: number; companyCode: string;
  }): Promise<DefaultResponse> {
    try {
      const response = await apiService.post<DefaultResponse>(companyEndpoints.matchCompany(), data);
      return response;
    } catch (error: any) {
      return {
        success: false,
        message: error?.response?.data?.message || error?.message || '회사 매칭 중 오류가 발생했습니다.'
      };
    }
  },

  async getSearchCompany(keyword: string): Promise<CompanyData[]> {
    try { 
      const response = await apiService.get<CompanyData[]>(companyEndpoints.searchCompany(keyword));
      return response;
    } catch (error) {
      return [];
    }
  },
}
